type CouponResetTag = { date: string; label: string; tone: 'warning' | 'success' | 'purple' }

const dateTimestamp = (value: string): number | null => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
  const timestamp = Date.parse(`${value}T00:00:00Z`)
  return Number.isFinite(timestamp) && new Date(timestamp).toISOString().slice(0, 10) === value ? timestamp : null
}

/** Show upcoming coupons as 'in' and past coupons as 'ago', relative to the value date. */
export const getCouponResetTags = (
  couponDates: readonly string[] | null | undefined,
  valueDate: string | null | undefined,
): CouponResetTag[] => {
  const valueTimestamp = valueDate ? dateTimestamp(valueDate) : null
  if (valueTimestamp == null || !couponDates?.length) return []
  return [...new Set(couponDates)].sort().flatMap((date): CouponResetTag[] => {
    const couponTimestamp = dateTimestamp(date)
    if (couponTimestamp == null) return []
    const difference = (couponTimestamp - valueTimestamp) / 86_400_000
    const days = Math.abs(difference)
    const duration = `${days} ${days === 1 ? 'day' : 'days'}`
    if (difference > 0) return [{ date, label: `Coupon Reset in ${duration}`, tone: 'warning' }]
    if (difference === 0) return [{ date, label: 'Coupon Reset Today', tone: 'success' }]
    return [{ date, label: `Coupon Reset ${duration} ago`, tone: 'purple' }]
  })
}
